import React from "react";
import {
  Box,
  Typography,
  Paper,
  Switch,
  Slider,
  FormControlLabel,
  Stack,
} from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import { useThemeSettings } from "../theme/ThemeSettingsContext";
import { useTheme } from "@mui/material/styles";

const Settings = () => {
  const theme = useTheme();
  const { darkMode, setDarkMode, fontSize, setFontSize } = useThemeSettings();

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "hidden", backgroundColor: theme.palette.background.paper }}>
    <Box sx={{ p: { xs: 1, md: 4 }, maxWidth: 600, mx: "auto" }}>
      <Typography variant="h5" fontWeight={600} mb={3} sx={{ color: theme.palette.text.primary }}>
        Accessibility & Settings
      </Typography>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          Appearance
        </Typography>
        <Stack direction="row" alignItems="center" spacing={2} mb={2}>
          <Brightness7Icon />
          <FormControlLabel
            control={
              <Switch
                checked={darkMode}
                onChange={e => setDarkMode(e.target.checked)}
                color="primary"
              />
            }
            label="Dark Mode"
          />
          <Brightness4Icon />
        </Stack>
        <Stack direction="row" alignItems="center" spacing={2}>
          <TextFieldsIcon />
          <Typography variant="body2">Text Size</Typography>
          <Slider
            min={12}
            max={24}
            step={1}
            value={fontSize}
            onChange={(_, v) => setFontSize(v)}
            valueLabelDisplay="auto"
            sx={{ width: 200 }}
          />
        </Stack>
      </Paper>
    </Box>
    </Box>
  );
};

export default Settings; 